import state from './moduleRelationshipRuleState'
import actions from './moduleRelationshipRuleActions'
import getters from './moduleRelationshipRuleGetters'
import mutations from './moduleRelationshipRuleMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
